import { CharacterResult } from "common/character/dto/CharacterResult";
import {
  RelateAnswer,
  TopicRelateAction,
  TopicRelateSelector,
} from "./TopicRelateAnswer.type";
import { RELATE_ANSWER } from "./TopicRelateAnswer.const";

export function answerRelateTypeGet(
  characterIdItem: string | CharacterResult,
  characters: CharacterResult[]
): RelateAnswer {
  let result: RelateAnswer = RELATE_ANSWER.N;
  let character: string | CharacterResult = characterIdItem;
  if (typeof characterIdItem === "string") {
    const characterItem = characterById(characterIdItem, characters);
    if (characterItem) {
      character = characterItem;
    }
  }
  if (typeof character !== "string") {
    if (character.answer && character.answer.correct === "y") {
      result = RELATE_ANSWER.Y_Y;
      if (character.relate.contain) {
        const containLetters = character.relate.contain;
        for (let i = 0; i < containLetters.length; i++) {
          const containLetter = containLetters[i];
          if (containLetter === character.letter) {
            continue;
          }
          const containChar = characterByLetter(containLetters[i], characters);
          if (containChar) {
            const containCharRelateAnswer = answerRelateTypeGet(
              containChar,
              characters
            );

            if (containCharRelateAnswer !== RELATE_ANSWER.Y_Y) {
              result = RELATE_ANSWER.Y_N;
              break;
            }
          }
        }
      }
    }
  }

  return result;
}

export function answerRelateTypeByLetterGet(
  letter: string,
  characters: CharacterResult[]
): RelateAnswer {
  let result: RelateAnswer = RELATE_ANSWER.N;
  const character = characterByLetter(letter, characters);
  if (character) {
    result = answerRelateTypeGet(character, characters);
  }

  return result;
}

export function characterById(
  characterId: string,
  characters: CharacterResult[]
): CharacterResult | null {
  return characterByProperty<string>("id", characterId, characters);
}

export function characterByLetter(
  letter: string,
  characters: CharacterResult[]
): CharacterResult | null {
  return characterByProperty<string>("letter", letter, characters);
}

export function characterByProperty<T>(
  fieldName: keyof CharacterResult,
  fieldValue: T,
  characters: CharacterResult[]
): CharacterResult | null {
  let result: CharacterResult | null = null;
  const character = characters.find(
    (charItem: CharacterResult) =>
      fieldName in charItem && charItem[fieldName] === fieldValue
  );
  if (character) {
    result = character;
  }

  return result;
}

export function topicRelateSelectorDefaultGet(): TopicRelateSelector {
  return {
    byLetter: (letter: string) => null,
    answerRelateTypeByLetter: (letter: string) => RELATE_ANSWER.N,
    containByLetter: (letter: string) => [],
  };
}

export function topicRelateActionDefaultGet(): TopicRelateAction {
  return {
    answerSet: (letter: string, correct: boolean) => null,
  };
}

export function charContainByLetter(
  letter: string,
  characters: CharacterResult[]
): string[] {
  const character = characterByLetter(letter, characters);
  let containLetters: string[] = [];
  if (character) {
    if (character.relate?.contain && character.relate?.contain.length >= 1) {
      containLetters = [...character.relate.contain];
    } else {
      containLetters = Array.from(character.letter);
      if (containLetters.length === 1) {
        containLetters = [];
      }
    }
  }
  return containLetters;
}
